import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './reviews.css'

const Reviews = (props) => {
  return (
    <div
      id={props.reviewsId}
      className={`thq-section-padding scroll-target ${props.rootClassName} `}
    >
      <div className="reviews-thq-max-width-elm thq-section-max-width">
        <div className="reviews-container10">
          <h2 className="thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="reviews-text21">Testimonials</span>
              </Fragment>
            )}
          </h2>
          <span className="reviews-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="reviews-text23">
                  Read what our customers have to say about our towing services.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card reviews-thq-card-elm1"
              >
                <div className="reviews-container12">
                  <img
                    alt={props.author1Alt1}
                    src={props.author1Src1}
                    className="reviews-image1"
                  />
                  <div className="reviews-container13">
                    <strong className="thq-body-large">
                      {props.author1Name1 ?? (
                        <Fragment>
                          <span className="reviews-text27">John Smith</span>
                        </Fragment>
                      )}
                    </strong>
                  </div>
                </div>
                <span className="reviews-text13 thq-body-small">
                  {props.review11 ?? (
                    <Fragment>
                      <span className="reviews-text26">
                        Evac provided fast and efficient towing service when I
                        was stranded on the highway. Highly recommended!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card reviews-thq-card-elm2"
              >
                <div className="reviews-container14">
                  <img
                    alt={props.author2Alt}
                    src={props.author2Src}
                    className="reviews-image2"
                  />
                  <div className="reviews-container15">
                    <strong className="thq-body-large">
                      {props.author2Name ?? (
                        <Fragment>
                          <span className="reviews-text29">Jane Doe</span>
                        </Fragment>
                      )}
                    </strong>
                  </div>
                </div>
                <span className="reviews-text15 thq-body-small">
                  {props.review2 ?? (
                    <Fragment>
                      <span className="reviews-text25">
                        I called Evac for a tow late at night, and they arrived
                        within minutes. Great service!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card reviews-thq-card-elm3"
              >
                <div className="reviews-container16">
                  <img
                    alt={props.author3Alt}
                    src={props.author3Src}
                    className="reviews-image3"
                  />
                  <div className="reviews-container17">
                    <strong className="thq-body-large">
                      {props.author3Name ?? (
                        <Fragment>
                          <span className="reviews-text28">David Johnson</span>
                        </Fragment>
                      )}
                    </strong>
                  </div>
                </div>
                <span className="reviews-text17 thq-body-small">
                  {props.review3 ?? (
                    <Fragment>
                      <span className="reviews-text24">
                        Professional and courteous team. Evac made a stressful
                        situation much easier to handle.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card reviews-thq-card-elm4"
              >
                <div className="reviews-container18">
                  <img
                    alt={props.author4Alt}
                    src={props.author4Src}
                    className="reviews-image4"
                  />
                  <div className="reviews-container19">
                    <strong className="thq-body-large">
                      {props.author4Name ?? (
                        <Fragment>
                          <span className="reviews-text20">Sarah Adams</span>
                        </Fragment>
                      )}
                    </strong>
                  </div>
                </div>
                <span className="reviews-text19 thq-body-small">
                  {props.review4 ?? (
                    <Fragment>
                      <span className="reviews-text22">
                        I was impressed by the prompt response and quality of
                        service provided by Evac. Thank you!
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Reviews.defaultProps = {
  author4Name: undefined,
  heading1: undefined,
  review4: undefined,
  content1: undefined,
  author4Src:
    'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=200',
  author3Src:
    'https://images.unsplash.com/photo-1492567291473-fe3dfc175b45?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=200',
  author3Alt: 'David Johnson - Freelance Designer',
  rootClassName: '',
  review3: undefined,
  author2Alt: 'Jane Doe - Marketing Manager, XYZ Inc.',
  author4Alt: 'Sarah Adams - Teacher',
  review2: undefined,
  review11: undefined,
  author1Src1:
    'https://images.unsplash.com/photo-1509967419530-da38b4704bc6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwMnw&ixlib=rb-4.1.0&q=80&w=200',
  author1Alt1: 'John Smith - CEO, ABC Company',
  author1Name1: undefined,
  reviewsId: '',
  author3Name: undefined,
  author2Name: undefined,
  author2Src:
    'https://images.unsplash.com/photo-1543269865-4430f94492b9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=200',
}

Reviews.propTypes = {
  author4Name: PropTypes.element,
  heading1: PropTypes.element,
  review4: PropTypes.element,
  content1: PropTypes.element,
  author4Src: PropTypes.string,
  author3Src: PropTypes.string,
  author3Alt: PropTypes.string,
  rootClassName: PropTypes.string,
  review3: PropTypes.element,
  author2Alt: PropTypes.string,
  author4Alt: PropTypes.string,
  review2: PropTypes.element,
  review11: PropTypes.element,
  author1Src1: PropTypes.string,
  author1Alt1: PropTypes.string,
  author1Name1: PropTypes.element,
  reviewsId: PropTypes.string,
  author3Name: PropTypes.element,
  author2Name: PropTypes.element,
  author2Src: PropTypes.string,
}

export default Reviews
